(function() {

    'use strict';

    var ItxFormNewsletterCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'itxFormNewsletterCmpTpl.html',
        controller: ItxFormNewsletterCmpCtrl,
        bindings: {
            data: '<'
        }
    };

    ItxFormNewsletterCmpCtrl.$inject = ['$scope', 'ItxNewsletterSvc', 'acceptanceService'];

    function ItxFormNewsletterCmpCtrl($scope, ItxNewsletterSvc, acceptanceService) {
        var _this = this;
        _this.model = {};

        this.copy = {
            'header': this.data.popup_suscripcion_3,
            'women': this.data.popup_suscripcion_4,
            'men': this.data.popup_suscripcion_5,
            'kids': this.data.popup_suscripcion_6,
            'personal_tailoring': this.data.popup_suscripcion_7,
            'choice_empty_error': this.data.popup_suscripcion_8,
            'title': this.data.popup_suscripcion_9,
            'email_placeholder': this.data.popup_suscripcion_10,
            'subscribe': this.data.popup_suscripcion_11,
            'email_empty_error': this.data.popup_suscripcion_12,
            'privacy_policy_read': this.data.popup_suscripcion_13,
            'privacy_policy_link': this.data.popup_suscripcion_14,
            'privacy_policy_read_2': '', // this.data.popup_suscripcion_15 FIX TODO
            'privacy_policy_error': this.data.popup_suscripcion_15,
            'success_message': this.data.popup_suscripcion_16,
            'sent_email': this.data.popup_suscripcion_17,
            'error_message': this.data.popup_suscripcion_18,
            'email_exist_message': this.data.popup_suscripcion_19,
        };

        _this.itxPattern = joyr.validation.regex.email();
        $scope.status = {};

        _this.sectionsSelected = [];
        
        _this.checkConditions = {
            'type': 'square',
            'name': 'policies',
            'title': this.copy.privacy_policy_read,
            'text_link': this.copy.privacy_policy_link,
            'title_2': this.privacy_policy_read_2,
            'lin_href': '',
            'error': this.copy.privacy_policy_error,
            'checked': false
        };

        _this.submitFormNewsletter = function (form) {
            var paramNewsletter = '';
            _.map(_this.sectionsSelected, function (key, index) {
                if (key.indexOf('NEWSLETTER') > -1) {
                    paramNewsletter = paramNewsletter + key;
                } else {
                    paramNewsletter = paramNewsletter + 'NEWSLETTER_' + key;
                }

                if (index < _this.sectionsSelected.length - 1) {
                    paramNewsletter = paramNewsletter + '#';
                }
            });
            if (_this.sectionsSelected.length !== 0 && form.$valid) {
                $scope.status.sent = true;
                if( _this.isChina() ){
                    acceptanceService.consent( 'NEWSLETTER', ["transferenciaforzosa"], _this.email );
                }

                ItxNewsletterSvc.subscribe(
                    _this.email,
                    paramNewsletter,
                    'web_pop_up_suscripcion',
                    true
                )
                    .then(function () {
                        $scope.status.success = true;
                    })
                    .catch(function (error) {
                        $scope.status.error = true;
                    });
            }
        };

        _this.isSendEnabled = function(form) {
            return !_this.isChina() && !form.$invalid && _this.sectionsSelected.length > 0;
        }

        _this.isChina = function(){
            return inditex.iCountryCode === 'CN';
        }
    }

    angular.module('itxApp.common').component('itxFormNewsletter', ItxFormNewsletterCmp);
})();
